import React, { useEffect, useState, forwardRef, useCallback, useMemo } from 'react';
import { Sketch } from '@uiw/react-color';
import i18n from '../../../i18n';

const ColorWithAlpha = forwardRef(({
  fieldName,
  wrapperClass = '',
  label,
  hideLabel = false,
  allowNull = true,
  inputType = 'text',
  value = '',
  step,
  errors = [],
  helpText = '',
  parent = '',
  autofocus = false,
  disabled = false,
  width = '',
  style = {},
  many = false,
  onChange = () => {},
  pk = null
}, ref) => {
  const [color, setColor] = useState('#ff0000');
  const [isOpen, setIsOpen] = useState(false);

  // Parse initial value
  useEffect(() => {
    if (value && value.startsWith('#')) {
      setColor(value);
    } else if (value === null || value === '') {
      setColor(null);
    }
  }, [value]);

  // Memoized color change handler for performance
  const handleColorChange = useCallback((newColor) => {
    setColor(newColor.hex);
    onChange({
      'name': fieldName,
      'value': newColor.hex,
      'label': newColor.hex
    });
  }, [fieldName, onChange]);

  // Handle clear/deselect color
  const handleClearColor = useCallback(() => {
    setColor(null);
    onChange({
      'name': fieldName,
      'value': null,
      'label': null
    });
    setIsOpen(false);
  }, [fieldName, onChange]);

  return (
    <div className={`color-picker-wrapper ${wrapperClass}`}>
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <button
          ref={ref}
          type="button"
          className={`${style.class} ${errors.length > 0 ? 'is-invalid' : ''}`}
          style={{
            width: '100px',
            height: '38px',
            backgroundColor: color || '#f8f9fa',
            border: '1px solid #ced4da !important',
            borderRadius: '0.375rem',
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.6 : 1,
            position: 'relative'
          }}
          onClick={() => !disabled && setIsOpen(!isOpen)}
          disabled={disabled}
          data-char_select_parent={parent}
        >
          {!color && (
            <span style={{
              position: 'absolute',
              width: '100%',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              fontSize: '12px',
              color: '#6c757d',
              fontWeight: 'bold'
            }}>
              {i18n.t('No Color')}
            </span>
          )}
        </button>
        
        {isOpen && !disabled && (
          <div style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            zIndex: 1000,
            marginTop: '4px',
            backgroundColor: 'white',
            border: '1px solid #ced4da',
            borderRadius: '0.375rem',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            padding: '12px'
          }}>
            <Sketch
              color={color || '#ff0000'}
              onChange={handleColorChange}
              presetColors={[]}
            />
            
            {/* Clear button when allowNull is true */}
            {allowNull && (
              <div style={{ marginTop: '12px', textAlign: 'center' }}>
                <button
                  type="button"
                  onClick={handleClearColor}
                  style={{
                    padding: '6px 12px',
                    fontSize: '12px',
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #ced4da',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    color: '#6c757d'
                  }}
                  onMouseOver={(e) => {
                    e.target.style.backgroundColor = '#e9ecef';
                  }}
                  onMouseOut={(e) => {
                    e.target.style.backgroundColor = '#f8f9fa';
                  }}
                >
                  Clear Color
                </button>
              </div>
            )}
            
            <div style={{
              marginTop: '8px',
              fontSize: '12px',
              color: '#6c757d',
              textAlign: 'center'
            }}>
              {color || 'No color selected'}
            </div>  
          </div>
        )}
      </div>
      
      {/* Click outside to close */}
      {isOpen && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999
          }}
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
});

export default ColorWithAlpha;

